module.exports = __webpack_public_path__ + "img/icons-close.85dbe9b0.svg";